import { render, staticRenderFns } from "./LaravelErrors.vue?vue&type=template&id=360cd55c"
import script from "./LaravelErrors.vue?vue&type=script&lang=js"
export * from "./LaravelErrors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports